import { fetchApi } from '@/services/api-client';

export const SESSIONS_PATH = '/admin/attendance/sessions';

export type AttendanceSessionKind = 'winter' | 'summer';

export type AttendanceSession = {
  id: string;
  schoolYearId: string;
  kind: AttendanceSessionKind;
  name: string;
  startDate: string;
  endDate: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
};

export const sessionsApi = {
  list: () => fetchApi<AttendanceSession[]>(SESSIONS_PATH),

  create: (data: {
    schoolYearId: string;
    kind: AttendanceSessionKind;
    name: string;
    startDate: string;
    endDate: string;
    active?: boolean;
  }) => fetchApi<AttendanceSession>(SESSIONS_PATH, { method: 'POST', body: JSON.stringify(data) }),

  update: (
    id: string,
    data: Partial<{
      kind: AttendanceSessionKind;
      name: string;
      startDate: string;
      endDate: string;
      active: boolean;
    }>
  ) => fetchApi<AttendanceSession>(`${SESSIONS_PATH}/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),

  remove: (id: string) => fetchApi(`${SESSIONS_PATH}/${id}`, { method: 'DELETE' }),
};
